import { PsHttpService, type PatSnapCommonResponseData } from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';

import type { CreateFMEAOutput, SummaryOutput } from '@/types/index';

export const PageApi = Symbol('PageApi');

export interface PageApi {
    summaryTitle(input: CreateFMEAOutput): Promise<SummaryOutput>
}

@injectable()
export class PageApiImpl extends PsHttpService implements PageApi {
    get options() {
        return {
            baseURL: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka`,
            headers: {
                'X-API-Version': '1.0',
            },
        };
    }

    summaryTitle(input: CreateFMEAOutput): Promise<SummaryOutput> {
        return this.get<PatSnapCommonResponseData<SummaryOutput>>({
            url: `/fmea/${input.fmea_id}/title/summary`,
        }).then((res) => {
            return res.data as SummaryOutput
        });
    }
}
